import { render, staticRenderFns } from "./CampoMoeda.vue?vue&type=template&id=23e77e78&"
import script from "./CampoMoeda.vue?vue&type=script&lang=js&"
export * from "./CampoMoeda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports